// Media Library, media picker and the image fields built on it.
export const mediaEn = {
  'media.subtitle': '{total} file · drop files anywhere to upload|{total} files · drop files anywhere to upload',
  'media.upload': 'Upload',
  'media.uploading': 'Uploading…',
  'media.uploadFiles': 'Upload files',
  'media.searchPlaceholder': 'Search filename or alt text',
  'media.uploaded': '{name} uploaded',
  'media.empty.title': 'No files yet',
  'media.empty.body': 'Upload images or drag them onto this page.',
  'media.prev': '← Previous',
  'media.next': 'Next →',
  'media.pageOf': 'Page {page} of {total}',
  'media.typeNotAllowed': '{name}: this file type isn’t allowed',
  'media.tooLarge': '{name}: larger than {size}',

  'media.detail.type': 'Type',
  'media.detail.size': 'Size',
  'media.detail.dimensions': 'Dimensions',
  'media.detail.uploaded': 'Uploaded',
  'media.detail.copyUrl': 'Copy URL',
  'media.detail.urlCopied': 'URL copied',
  'media.detail.usedIn': 'Used in',
  'media.detail.checking': 'Checking…',
  'media.detail.usageError': 'Could not check where this file is used.',
  'media.detail.unused': 'Nothing uses this file yet.',
  'media.usage.page': 'page',
  'media.usage.article': 'article',
  'media.usage.product': 'product',
  'media.usage.category': 'category',
  'media.usage.industry': 'industry',
  'media.usage.swatch': 'material or finish',
  'media.usage.site': 'site',
  'media.detail.altText': 'Alt text · {language}',
  'media.detail.altTextPrimary': 'Alt text · {language} (primary)',
  'media.detail.altHint': 'Describe the image for screen readers and Google Images.',
  'media.detail.altFallback': 'Falls back to {language}',
  'media.detail.altSaved': 'Alt text saved',
  'media.detail.saveAlt': 'Save alt text',
  'media.detail.deleteTitleUsed': 'Delete a file used in {count} place?|Delete a file used in {count} places?',
  'media.detail.deleteTitleUnused': 'Delete this file?',
  'media.detail.deleteBodyUsed': '{titles} will show a missing image.',
  'media.detail.deleteBodyUsedMore': '{titles} and {more} more will show a missing image.',
  'media.detail.deleteBodyUnused': 'Nothing uses this file. It cannot be restored.',
  'media.detail.deleteAnyway': 'Delete anyway',
  'media.detail.deleted': 'File deleted',

  'media.picker.title': 'Choose From Media Library',
  'media.picker.noMatch': 'No files match. Upload one above.',
  'media.picker.prev': '← Prev',
  'media.picker.useSelected': 'Use selected',

  'media.field.replace': 'Replace',
  'media.field.choose': 'Choose image',
  'media.field.remove': 'Remove',
  'media.field.add': '+ Add',
  'media.field.coverHint': 'The first image is the cover used on cards and social previews.',
  'media.field.cover': 'Cover',
  'media.field.moveLeft': 'Move left',
  'media.field.moveRight': 'Move right',
  'media.field.usingImage': 'Using {language} image',
  'media.field.chooseLocale': 'Choose {code} image',
  'media.field.useImage': 'Use {language} image',
  'media.field.noImagesEither': 'No images in {language} either.',
  'media.field.usingGallery': 'Using the {language} gallery.',
  'media.field.customise': 'Customise for {code}',
  'media.field.useGallery': 'Use {language} gallery',
} as const

export const mediaId: Record<keyof typeof mediaEn, string> = {
  'media.subtitle': '{total} file · seret file ke mana saja untuk mengunggah',
  'media.upload': 'Unggah',
  'media.uploading': 'Mengunggah…',
  'media.uploadFiles': 'Unggah file',
  'media.searchPlaceholder': 'Cari nama file atau teks alternatif',
  'media.uploaded': '{name} berhasil diunggah',
  'media.empty.title': 'Belum ada file',
  'media.empty.body': 'Unggah gambar atau seret ke halaman ini.',
  'media.prev': '← Sebelumnya',
  'media.next': 'Berikutnya →',
  'media.pageOf': 'Halaman {page} dari {total}',
  'media.typeNotAllowed': '{name}: tipe file ini tidak diizinkan',
  'media.tooLarge': '{name}: melebihi {size}',

  'media.detail.type': 'Tipe',
  'media.detail.size': 'Ukuran',
  'media.detail.dimensions': 'Dimensi',
  'media.detail.uploaded': 'Diunggah',
  'media.detail.copyUrl': 'Salin URL',
  'media.detail.urlCopied': 'URL disalin',
  'media.detail.usedIn': 'Digunakan di',
  'media.detail.checking': 'Memeriksa…',
  'media.detail.usageError': 'Tidak dapat memeriksa di mana file ini digunakan.',
  'media.detail.unused': 'Belum ada yang menggunakan file ini.',
  'media.usage.page': 'halaman',
  'media.usage.article': 'artikel',
  'media.usage.product': 'produk',
  'media.usage.category': 'kategori',
  'media.usage.industry': 'industri',
  'media.usage.swatch': 'bahan atau finishing',
  'media.usage.site': 'situs',
  'media.detail.altText': 'Teks alternatif · {language}',
  'media.detail.altTextPrimary': 'Teks alternatif · {language} (utama)',
  'media.detail.altHint': 'Deskripsikan gambar untuk pembaca layar dan Google Images.',
  'media.detail.altFallback': 'Memakai {language} jika kosong',
  'media.detail.altSaved': 'Teks alternatif disimpan',
  'media.detail.saveAlt': 'Simpan teks alternatif',
  'media.detail.deleteTitleUsed': 'Hapus file yang digunakan di {count} tempat?',
  'media.detail.deleteTitleUnused': 'Hapus file ini?',
  'media.detail.deleteBodyUsed': '{titles} akan menampilkan gambar yang hilang.',
  'media.detail.deleteBodyUsedMore': '{titles} dan {more} lainnya akan menampilkan gambar yang hilang.',
  'media.detail.deleteBodyUnused': 'Tidak ada yang menggunakan file ini. File tidak dapat dipulihkan.',
  'media.detail.deleteAnyway': 'Tetap hapus',
  'media.detail.deleted': 'File dihapus',

  'media.picker.title': 'Pilih dari Pustaka Media',
  'media.picker.noMatch': 'Tidak ada file yang cocok. Unggah file di atas.',
  'media.picker.prev': '← Sebelumnya',
  'media.picker.useSelected': 'Gunakan yang dipilih',

  'media.field.replace': 'Ganti',
  'media.field.choose': 'Pilih gambar',
  'media.field.remove': 'Hapus',
  'media.field.add': '+ Tambah',
  'media.field.coverHint': 'Gambar pertama menjadi sampul yang dipakai pada kartu dan pratinjau media sosial.',
  'media.field.cover': 'Sampul',
  'media.field.moveLeft': 'Geser ke kiri',
  'media.field.moveRight': 'Geser ke kanan',
  'media.field.usingImage': 'Memakai gambar {language}',
  'media.field.chooseLocale': 'Pilih gambar {code}',
  'media.field.useImage': 'Pakai gambar {language}',
  'media.field.noImagesEither': 'Di {language} juga belum ada gambar.',
  'media.field.usingGallery': 'Memakai galeri {language}.',
  'media.field.customise': 'Sesuaikan untuk {code}',
  'media.field.useGallery': 'Pakai galeri {language}',
}
